<template>
  <v-row>
    <v-col>
      <ClinicTherapyList />
    </v-col>
  </v-row>
</template>

<script>
  import ClinicTherapyList from "@/components/config/template/clinic-therapy/list.vue";

  export default {
    name: "TemplateClinicTerapyConfig",
    components: {
      ClinicTherapyList,
    },
  };
</script>

<style lang="scss" scoped></style>
